import { request } from '../../utils/axios';

const publicPrefix = '/public';
const sysPrefix = '/sys';

// ==================== 机构申请注册 ====================
export const CheckOrgInfo = async (data) => {
  return request.post(`${publicPrefix}/register/verifyOrg`, data);
};
export const RegisterOrg = async (data) => {
  return request.post(`${publicPrefix}/register/registerOrg`, data);
};
export const updateOrgInfo = async (data) => {
  return request.post(`${publicPrefix}/register/updateRegisterInfo`, data);
};

// ==================== 登录相关接口 ====================
export const updatePassword = async (data) => {
  const formData = new FormData();
  Object.entries(data || {}).forEach(([key, value]) => formData.append(key, value));
  return request.post(`${publicPrefix}/user/updatePassword`, formData);
};
export const getQrCode = async (params) => {
  return request.get(`${publicPrefix}/register/getRegisterLoginQr`, { params });
};
export const checkLoginStatus = async (params) => {
  return request.get(`${publicPrefix}/register/getQrScanningResult`, { params });
};
export const getUserInfo = async (params) => {
  return request.get(`${publicPrefix}/register/getPubUserInfo`, { params });
};
export const accountLogin = async (data) => {
  return request.post(`${publicPrefix}/register/accountLogin`, data);
};
export const forgotPassword = async (data) => {
  return request.post(`${publicPrefix}/register/forgotPassword`, data);
};
export const verifyResetToken = async (params) => {
  return request.get(`${publicPrefix}/register/reset`, { params });
};
export const resetPasswordByToken = async (data) => {
  return request.post(`${publicPrefix}/register/doReset`, data);
};

// ==================== 收藏 ====================
export const getFavorite = async (params) => {
  return request.get(`${publicPrefix}/favorite/list`, { params });
};
export const addFavorite = async (data) => {
  return request.post(`${publicPrefix}/favorite/add`, data);
};
export const checkFavorite = async (params) => {
  return request.get(`${publicPrefix}/favorite/check`, { params });
};
export const removeFavorite = async (params) => {
  return request.delete(`${publicPrefix}/favorite/remove`, { params });
};

// ==================== 消息通知 ====================
export const getMessageList = async (params) => {
  return request.get(`${publicPrefix}/message/list`, { params });
};
export const getUnreadMessageCount = async (params) => {
  return request.get(`${publicPrefix}/message/unreadCount`, { params });
};
export const markMessageAsRead = async (params) => {
  return request.post(`${publicPrefix}/message/markAsRead`, null, { params });
};
export const markAllMessagesAsRead = async (params) => {
  return request.post(`${publicPrefix}/message/markAllAsRead`, null, { params });
};
export const deleteMessage = async (params) => {
  return request.delete(`${publicPrefix}/message/delete`, { params });
};

// ==================== 文件上传 / 字典 ====================
export const uploadFile = (data) => request.post(`${sysPrefix}/common/upload`, data);

export const getCategoryInfo = async (params) => {
  return request.get(`${sysPrefix}/category/loadDictTreeRoot`, { params });
};

// 加载分类字典指定节点下的子分类（pcode=B03A07 仪器设备服务 → 行业分类列表）
export const getCategoryChildren = async (params) => {
  return request.get(`${sysPrefix}/category/loadTreeData`, { params });
};

export const getDictItemInfo = async (params) => {
  return request.get(`${sysPrefix}/api/queryDictItemsByCode`, { params });
};

// ==================== 组织机构（所属管理机关） ====================
export const getDepartTreeList = async (params) => {
  return request.get(`${sysPrefix}/sysDepart/queryTreeList`, { params });
};
